import { getPlatformType, isTitansAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from "@nibfe/mkt-env-api";
import { PlatformType } from "@nibfe/mkt-env-api";
import { navigateTo, redirectTo } from '@max/meituan-uni-navigate';
import { TechStackUtil } from '@nibfe/mkt-common-utils';
const isWeb = true;
import { useEngineContext } from "./useEngineContext";
export function useMonitorNavigation() {
    const isInEditor = TechStackUtil.isInEditor();
    const ctx = useEngineContext();
    // @ts-expect-error as any
    const monitorNavigateTo = (navigationOptions) => {
        var _a;
        const { url } = navigationOptions;
        try {
            const msg = validateUrl(url);
            if (msg) {
                ctx._raptorReport.reportLog(msg, new Error(`${url}非法`), {
                    category: '[MCP跳转监控]',
                    level: 'warn'
                });
            }
        }
        catch (e) {
            ctx._raptorReport.reportLog('URL合法性校验异常', e, {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
        }
        if (isInEditor) {
            ctx._uiInteractionAPI.toast.show({
                content: `跳转至 ${url}`
            });
            return;
        }
        return (_a = navigateTo(Object.assign(Object.assign({}, navigationOptions), { verifyUrl: (res) => {
                var _a;
                (_a = navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.verifyUrl) === null || _a === void 0 ? void 0 : _a.call(navigationOptions, res);
                if (!res.status) {
                    ctx._raptorReport.reportLog('navigateTo verifyUrl失败', `${(res === null || res === void 0 ? void 0 : res.message) || ''} | ${res.url}`, {
                        category: '[MCP跳转监控]',
                        level: 'warn'
                    });
                }
            } }))) === null || _a === void 0 ? void 0 : _a.catch((e) => {
            ctx._raptorReport.reportLog('navigateTo跳转错误', e, {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
            throw e;
        });
    };
    // @ts-expect-error as any
    const monitorRedirectTo = (navigationOptions) => {
        var _a;
        const { url } = navigationOptions;
        try {
            const msg = validateUrl(url);
            if (msg) {
                ctx._raptorReport.reportLog(msg, new Error(`${url}非法`), {
                    category: '[MCP跳转监控]',
                    level: 'warn'
                });
            }
        }
        catch (e) {
            ctx._raptorReport.reportLog('URL合法性校验异常', e, {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
        }
        if (isInEditor) {
            ctx._uiInteractionAPI.toast.show({
                content: `重定向至 ${url}`
            });
            return;
        }
        return (_a = redirectTo(Object.assign(Object.assign({}, navigationOptions), { verifyUrl: (res) => {
                var _a;
                (_a = navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.verifyUrl) === null || _a === void 0 ? void 0 : _a.call(navigationOptions, res);
                if (!res.status) {
                    ctx._raptorReport.reportLog('redirectTo verifyUrl失败', `${(res === null || res === void 0 ? void 0 : res.message) || ''} | ${res.url}`, {
                        category: '[MCP跳转监控]',
                        level: 'warn'
                    });
                }
            } }))) === null || _a === void 0 ? void 0 : _a.catch((e) => {
            ctx._raptorReport.reportLog('redirectTo跳转错误', e, {
                category: '[MCP跳转监控]',
                level: 'warn'
            });
            throw e;
        });
    };
    return {
        monitorNavigateTo,
        monitorRedirectTo
    };
}
function validateUrl(url) {
    const platformType = getPlatformType();
    const isInApp = isTitansAppOrWebview();
    const isInWXH5 = isWeixinMiniProgramOrWeixinWebview() && isWeb;
    /* APP场景 */
    if (isInApp) {
        if (maybeWXMiniLink(url))
            return '站内跳转小程序';
        if (maybeEnvokeLink(url))
            return '站内跳转唤端';
        return null;
    }
    /* 小程序内H5场景 */
    if (isInWXH5) {
        if (maybeAppLink(url))
            return '小程序内打开站内链接';
        if (maybeEnvokeLink(url))
            return '小程序内唤端';
        if (platformType === PlatformType.mtHotelMinaWebview && url.startsWith('/index'))
            return '酒小内打开美小';
        if (url.includes('index/pages/h5'))
            return '在非酒店WebView中打开H5';
        return null;
    }
    /* 其他小程序 & 外投场景 */
    if (maybeAppLink(url)) {
        return '非微信小程序&外投场景直接打开站内链接';
    }
    return null;
}
const maybeWXMiniLink = (url) => {
    return url.startsWith('/pages') || url.startsWith('/index');
};
const maybeEnvokeLink = (url) => {
    const envokePattern = ['https://i.meituan.com/c', 'https://dpurl.cn', 'https://m.dianping.com/awp/hfe/block-page/call-native'];
    return envokePattern.some(pattern => url.startsWith(pattern));
};
const maybeAppLink = (url) => {
    return url.startsWith('imeituan://') || url.startsWith('dianping://');
};
